module.exports = __webpack_public_path__ + "static/media/payments-accepted.f97be055.png";